import styled from "styled-components";

export const BurgerIconDefaultBox = styled.i`
  width: 26px;
  height: 18px;
  background-image: url("${props => props.theme.images.spriteSheet.toString()}");
  background-repeat: no-repeat;
  background-position: -974px -648px;
`